import React from 'react'

const OnlineCreditApprovalAustin = () => {
  return (
    <>
        <section className='common-wrap online-credit-wrap'>
            <div className='container'>
                <iframe 
                    src="https://www.700dealer.com/QuickQualify/1d45fe5b236a4d0f95ea267cc98658b0-2025522" 
                    width="100%" 
                    height="1550px" 
                    frameBorder="0">
                </iframe>
            </div>
        </section>
    </>
  )
}

export default OnlineCreditApprovalAustin